(function () {
  function syncThumb(scroller, thumb) {
    var thumbRatio = scroller.clientWidth / scroller.scrollWidth;
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var scrollRatio = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
    var thumbPercent = thumbRatio * 100;
    thumb.style.width = thumbPercent + '%';
    thumb.style.marginInlineStart = scrollRatio * (100 - thumbPercent) + '%';
  }

  function updateScrollbarVisibility(section) {
    section.querySelectorAll('.collection-tabs__panel').forEach(function (panel) {
      var scroller = panel.querySelector('slideshow-slides');
      var track = panel.querySelector('[data-3dids-scrollbar-track]');
      var thumb = panel.querySelector('[data-3dids-scrollbar-thumb]');

      if (!scroller) return;

      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 1;

      var component = scroller.closest('slideshow-component');
      var arrows = component && component.querySelector('slideshow-arrows');
      if (arrows) {
        arrows.hidden = !hasOverflow;
      }

      if (!track || !thumb) return;

      track.classList.toggle('collection-tabs__has-scroll', hasOverflow);

      if (!hasOverflow) return;

      syncThumb(scroller, thumb);

      if (!scroller.dataset.scrollbarBound) {
        scroller.dataset.scrollbarBound = 'true';
        scroller.addEventListener('scroll', function () {
          syncThumb(scroller, thumb);
        });
      }
    });
  }

  function showActivePanel(section) {
    var checked = section.querySelector('.collection-tabs__radio:checked');
    if (!checked) return;

    var activeId = checked.id.replace('collection-tab-', '');

    section.querySelectorAll('.collection-tabs__panel').forEach(function (panel) {
      panel.style.display = panel.dataset.tabPanel === activeId ? 'block' : 'none';
    });

    section.querySelectorAll('.collection-tabs__tab-image').forEach(function (image) {
      var label = image.closest('.collection-tabs__tab');
      var isActive = label && label.getAttribute('for') === checked.id;
      image.style.outlineColor = isActive ? 'var(--collection-tabs-active-color)' : 'transparent';
    });
  }

  function initCollectionTabs(section) {
    var source = section.querySelector('[data-3dids-tabs-source]');
    var nav = section.querySelector('[data-3dids-tabs-nav]');
    var panels = section.querySelector('[data-3dids-tabs-panels]');

    if (source && nav && panels) {
      source.querySelectorAll(':scope > .collection-tabs__tab').forEach(function (tab) {
        nav.appendChild(tab);
      });

      source.querySelectorAll(':scope > .collection-tabs__panel').forEach(function (panel) {
        panels.appendChild(panel);
      });

      source.remove();
    }

    if (!section.dataset.tabsBound) {
      section.dataset.tabsBound = 'true';
      section.addEventListener('change', function (event) {
        if (event.target.classList.contains('collection-tabs__radio')) {
          showActivePanel(section);
          updateScrollbarVisibility(section);
        }
      });
    }

    showActivePanel(section);
    updateScrollbarVisibility(section);
  }

  function init(root) {
    (root || document).querySelectorAll('.collection-tabs').forEach(initCollectionTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('.collection-tabs').forEach(updateScrollbarVisibility);
  });

  // The Shopify theme editor re-renders sections via AJAX (live preview) without
  // a full page reload, so DOMContentLoaded only fires once. Re-run on the
  // editor's section lifecycle events to relocate and re-bind tabs/panels
  // every time a section is (re)rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
